import * as React from 'react';

function SvgPlatformFee(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={28.911} height={28.002} {...props}>
      <defs>
        <style>
          {
            '.platform_fee_svg__cls-2{fill:#57be92}.platform_fee_svg__cls-3{fill:#22b27f}.platform_fee_svg__cls-6{fill:#ffbd86}'
          }
        </style>
      </defs>
      <g id="platform_fee_svg__bonus">
        <path
          id="platform_fee_svg__Path_7776"
          fill="#fac600"
          d="M235.068 73.222h4.648v2.041h-4.648z"
          transform="translate(-221.794 -69.542)"
        />
        <path
          id="platform_fee_svg__Path_7777"
          d="M205.172 8.052h-3.442a.812.812 0 00-.774 1.05 4.379 4.379 0 001.892 2.716h4.652a4.378 4.378 0 001.888-2.718.812.812 0 00-.775-1.05z"
          className="platform_fee_svg__cls-2"
          transform="translate(-189.574 -8.052)"
        />
        <path
          id="platform_fee_svg__Path_7778"
          d="M299.4 9.106a4.378 4.378 0 01-1.892 2.716h-1.19a5.95 5.95 0 001.93-2.716.8.8 0 00-.774-1.05h1.152a.812.812 0 01.774 1.05z"
          className="platform_fee_svg__cls-3"
          transform="translate(-279.583 -8.056)"
        />
        <path
          id="platform_fee_svg__Path_7779"
          fill="#e8b800"
          d="M296.315 74.745h1.19v1.869h-1.19z"
          transform="translate(-279.583 -70.979)"
        />
        <path
          id="platform_fee_svg__Path_7780"
          d="M135.814 121.658a.776.776 0 01-.776-.776v-7.824a4.137 4.137 0 00-1.981-3.511l-2.743-1.7h-4.658l-2.743 1.7a4.137 4.137 0 00-1.981 3.511v7.824a.776.776 0 01-.776.776 1.043 1.043 0 00-1.043 1.043v1.993a1.043 1.043 0 001.043 1.043h15.658a1.043 1.043 0 001.043-1.043V122.7a1.043 1.043 0 00-1.043-1.042z"
          className="platform_fee_svg__cls-2"
          transform="translate(-112.387 -102.212)"
        />
        <path
          id="platform_fee_svg__Path_7781"
          d="M304.053 122.7v2a1.043 1.043 0 01-1.043 1.043h-1.152a1.043 1.043 0 001.042-1.043v-1.308a.722.722 0 00-.722-.722h-.32a.777.777 0 01-.777-.777v-8.8a2.633 2.633 0 00-.656-1.774 21.717 21.717 0 00-4.11-3.472h1.195l2.743 1.7a4.139 4.139 0 011.981 3.511v7.824a.776.776 0 00.776.776 1.043 1.043 0 011.043 1.042z"
          className="platform_fee_svg__cls-3"
          transform="translate(-279.584 -102.213)"
        />
        <g id="platform_fee_svg__Group_8511" transform="translate(0 19.146)">
          <path
            id="platform_fee_svg__Path_7783"
            fill="#fed2a4"
            d="M95.87 353.285a1.765 1.765 0 00-2.184-.662l-8.1 2.675h-.015a1.4 1.4 0 00-.264-2.717l-4.444-.874a29.231 29.231 0 00-3.04-.532 4.692 4.692 0 00-2.209 1.115c-1.436 1.019-2.878.715-4.349.217v5.418l3.544-.207a5.135 5.135 0 012.212.3l3.391 1.249c2.319.854 4.359-.143 6.513-.869 2.728-.919 5.522-1.629 8.243-2.569a1.765 1.765 0 00.702-2.544z"
            transform="translate(-67.242 -350.944)"
          />
          <path
            id="platform_fee_svg__Path_7784"
            d="M95.164 397.427c-2.721.94-5.515 1.649-8.243 2.569-2.154.725-4.194 1.723-6.513.869l-3.391-1.249a5.137 5.137 0 00-2.212-.3l-3.544.207v-1.159l3.544-.207a5.594 5.594 0 012.321.189l3.391 1.249c2.318.854 4.25-.034 6.4-.76 2.728-.919 5.522-1.629 8.243-2.569a1.756 1.756 0 00.886-1 1.767 1.767 0 01-.882 2.161z"
            className="platform_fee_svg__cls-6"
            transform="translate(-67.237 -392.544)"
          />
          <path
            id="platform_fee_svg__Path_7785"
            fill="#717171"
            d="M3.315 355.974H.9a.9.9 0 01-.9-.9v-7.051a.9.9 0 01.9-.9h2.415a.9.9 0 01.9.9v7.051a.9.9 0 01-.9.9z"
            transform="translate(0 -347.119)"
          />
          <path
            id="platform_fee_svg__Path_7786"
            d="M40.151 348.024v7.051a.9.9 0 01-.9.9h-1.167a.9.9 0 00.9-.9v-7.051a.9.9 0 00-.9-.9h1.164a.9.9 0 01.903.9z"
            transform="translate(-35.934 -347.122)"
          />
        </g>
        <path
          id="platform_fee_svg__Path_7787"
          d="M219.973 388.445a1.326 1.326 0 01-.012.208 1.4 1.4 0 01-.939 1.142h.015l.1-.033a1.164 1.164 0 01-.494.092l-.114-.01-5.586-1.259a.451.451 0 11.424-.8s4.989 1.071 5.247 1.119a1.667 1.667 0 001.359-.459z"
          className="platform_fee_svg__cls-6"
          transform="translate(-200.691 -366.296)"
        />
        <text
          id="platform_fee_svg___"
          fill="#fff"
          fontFamily="SegoeUI, Segoe UI"
          fontSize={8}
          transform="translate(15.444 16.684)"
        >
          <tspan x={-2.156} y={0}>
            {'\u20B9'}
          </tspan>
        </text>
      </g>
    </svg>
  );
}

export default SvgPlatformFee;
